import type { TriggerReportJobRequestPayload } from '@weft/api-definition';
import type { ReportData } from '@weft/types';
import { ReportDataSchema } from '@weft/types';
import type { UseMutationOptions } from 'react-query';
import { useQueryClient } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useTriggerReportJob(
  options?: UseMutationOptions<ReportData, unknown, TriggerReportJobRequestPayload>) {
  const queryClient = useQueryClient();

  return useMutation(async (triggerReportJobRequest) => {
    const api = getPrivateApi();
    const triggerReportJobQuery = await api.triggerReportJob({ triggerReportJobRequest });

    return ReportDataSchema.parse(triggerReportJobQuery);
  }, { onSuccess: async () => queryClient.invalidateQueries(['reports']), ...options });
}